'use client';
import React from 'react';
import ClientLayoutInner from './ClientLayoutInner';

export default function ClientLayout({ children }: { children: React.ReactNode }) {
  return <ClientLayoutInner>{children}</ClientLayoutInner>;
}
